<template>
  <div class="layout-body">
    <!-- 顶部导航 -->
    <div class="layout-header">
      <div class="header-left">
        <span class="header-logo">新能源精细化功率预测平台</span>
        <span class="header-time">{{ currentTime }}</span>
      </div>
      <div class="header-right">
        <router-link v-if="viewType === '1' || viewType === '3'" to="/wind" class="header-tab" active-class="tab-active">风电</router-link>
        <router-link v-if="viewType === '2' || viewType === '3'" to="/solar" class="header-tab" active-class="tab-active">光伏</router-link>
        <router-link to="/admin/overview" class="header-tab" :class="{ 'tab-active': isAdminRoute }">系统管理</router-link>
        <div class="header-user-dropdown" @click.stop="showUserMenu = !showUserMenu" v-click-outside="closeUserMenu">
          <span class="header-user-name">{{ userName }}</span>
          <span class="header-user-arrow" :class="{ open: showUserMenu }">▾</span>
          <div v-if="showUserMenu" class="user-dropdown-menu">
            <div class="dropdown-item logout-item" @click="handleLogout">退出登录</div>
          </div>
        </div>
      </div>
    </div>

    <!-- 页面内容 -->
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'MainLayout',
  directives: {
    'click-outside': {
      bind(el, binding) {
        el.__clickOutside = (event) => {
          if (!el.contains(event.target)) {
            binding.value()
          }
        }
        document.addEventListener('click', el.__clickOutside)
      },
      unbind(el) {
        document.removeEventListener('click', el.__clickOutside)
      }
    }
  },
  data() {
    return {
      currentTime: '',
      userName: '',
      viewType: '3',
      showUserMenu: false
    }
  },
  computed: {
    isAdminRoute() {
      return this.$route.path.startsWith('/admin')
    }
  },
  mounted() {
    this.userName = sessionStorage.getItem('userName') || ''
    this.viewType = sessionStorage.getItem('viewType') || '3'
    this.updateTime()
    setInterval(() => {
      this.updateTime()
    }, 1000)
  },
  methods: {
    closeUserMenu() {
      this.showUserMenu = false
    },
    handleLogout() {
      sessionStorage.removeItem('isLoggedIn')
      sessionStorage.removeItem('userName')
      sessionStorage.removeItem('role')
      sessionStorage.removeItem('token')
      sessionStorage.removeItem('tokenExpire')
      sessionStorage.removeItem('viewType')
      sessionStorage.removeItem('locationStore')
      this.$router.replace('/login')
    },
    updateTime() {
      const now = new Date()
      const year = now.getFullYear()
      const month = String(now.getMonth() + 1).padStart(2, '0')
      const day = String(now.getDate()).padStart(2, '0')
      const hours = String(now.getHours()).padStart(2, '0')
      const minutes = String(now.getMinutes()).padStart(2, '0')
      const seconds = String(now.getSeconds()).padStart(2, '0')
      const weekDays = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六']
      const weekDay = weekDays[now.getDay()]
      this.currentTime = `${year}-${month}-${day} ${hours}:${minutes}:${seconds} ${weekDay}`
    }
  }
}
</script>

<style scoped>
.layout-body {
  height: 100vh;
  width: 100vw;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background: linear-gradient(135deg, #080f1f 0%, #0d1a33 50%, #080f1f 100%);
}

.layout-header {
  height: 72px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 32px;
  flex-shrink: 0;
  position: relative;
  z-index: 1000;
}

.layout-header::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 5%;
  width: 90%;
  height: 1px;
  background: linear-gradient(90deg, transparent, rgba(0, 216, 255, 0.3), rgba(0, 216, 255, 0.6), rgba(0, 216, 255, 0.3), transparent);
}

.header-left {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
}

.header-logo {
  font-size: 22px;
  font-weight: 800;
  background: linear-gradient(90deg, #00d8ff, #4dc9f6, #00d8ff);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  letter-spacing: 6px;
  white-space: nowrap;
}

.header-time {
  font-size: 12px;
  color: rgba(0, 216, 255, 0.5);
  letter-spacing: 2px;
  white-space: nowrap;
  padding-left: 2px;
}

.header-right {
  display: flex;
  align-items: center;
  gap: 16px;
}

.header-user-dropdown {
  position: relative;
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 6px 14px;
  border: 1px solid rgba(0, 216, 255, 0.2);
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.3s ease;
  user-select: none;
}

.header-user-dropdown:hover {
  border-color: rgba(0, 216, 255, 0.5);
  background: rgba(0, 216, 255, 0.06);
}

.header-user-name {
  color: rgba(0, 216, 255, 0.85);
  font-size: 13px;
}

.header-user-arrow {
  color: rgba(0, 216, 255, 0.5);
  font-size: 10px;
  transition: transform 0.2s;
}

.header-user-arrow.open {
  transform: rotate(180deg);
}

.user-dropdown-menu {
  position: absolute;
  top: calc(100% + 6px);
  right: 0;
  min-width: 140px;
  background: rgba(12, 25, 46, 0.95);
  border: 1px solid rgba(0, 216, 255, 0.2);
  border-radius: 6px;
  padding: 4px 0;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(8px);
  z-index: 1001;
}

.dropdown-item {
  padding: 10px 16px;
  font-size: 13px;
  color: rgba(0, 216, 255, 0.75);
  cursor: pointer;
  transition: all 0.2s;
  white-space: nowrap;
}

.dropdown-item:hover {
  background: rgba(0, 216, 255, 0.1);
  color: #00d8ff;
}

.dropdown-item.logout-item {
  color: rgba(255, 255, 255, 0.55);
}

.dropdown-item.logout-item:hover {
  color: #ff6b6b;
  background: rgba(255, 107, 107, 0.1);
}

.header-tab {
  padding: 8px 28px;
  font-size: 15px;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.55);
  text-decoration: none;
  cursor: pointer;
  transition: all 0.3s ease;
  background: rgba(0, 216, 255, 0.04);
  white-space: nowrap;
  border: 1px solid rgba(0, 216, 255, 0.15);
  border-radius: 6px;
  letter-spacing: 2px;
  position: relative;
}

.header-tab:hover {
  color: #00d8ff;
  background: rgba(0, 216, 255, 0.08);
  border-color: rgba(0, 216, 255, 0.4);
  box-shadow: 0 0 20px rgba(0, 216, 255, 0.1);
}

.header-tab.tab-active {
  color: #fff;
  background: linear-gradient(135deg, rgba(0, 216, 255, 0.25), rgba(0, 180, 220, 0.15));
  border-color: #00d8ff;
  box-shadow: 0 0 24px rgba(0, 216, 255, 0.2), inset 0 0 12px rgba(0, 216, 255, 0.05);
}
</style>
